import React, { useEffect, useRef, useState } from "react";

import PromptFragmentsMacrosList from "./components/promptFragmentsMacros";
import PromptVariablesMacrosList from "./components/promptVariablesMacrosList";

function PromptFragmentsValueTextArea({
  className = "",
  handleChange,
  textAreaValue,
  // tableData,
  setFormDataWithTextAreaValue,
}) {
  // fragments macros
  const [fragmentsData, setFragmentsData] = useState([]);
  const [showFragmentsMacros, setShowFragmentsMacros] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  // common states
  const [macroSearch, setMacroSearch] = useState("");
  const [cursorPosition, setCursorPosition] = useState(0);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    position: "above",
  });
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [isIOS, setIsIOS] = useState(false);

  // variables macros
  const [selectedVariablesMacrosIndex, setSelectedVariablesMacrosIndex] =
    useState(-1);
  const [variablesData, setVariablesData] = useState([]);
  const [showVariablesMacros, setShowVariablesMacros] = useState(false);

  const textareaRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(isIOSDevice);

    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (textAreaValue === "") {
      setShowFragmentsMacros(false);
      setShowVariablesMacros(false);
    }
  }, [textAreaValue]);

  const handleMacroSelect = (macro) => {
    const value = textAreaValue || "";
    const beforeCursor = value.substring(
      0,
      cursorPosition - macroSearch.length - 1
    );
    const afterCursor = value.substring(cursorPosition);

    let newValue;
    if (showFragmentsMacros)
      newValue = `${beforeCursor}{{${macro.key}}}${afterCursor}`;
    if (showVariablesMacros)
      newValue = `${beforeCursor}@${macro.name}${afterCursor}`;
    // setPromptFragmentsFormData({
    //   ...promptFragmentsFormData,
    //   value: newValue,
    // });

    setFormDataWithTextAreaValue(newValue);
    if (showFragmentsMacros) setShowFragmentsMacros(false);
    if (showVariablesMacros) setShowVariablesMacros(false);
    setMacroSearch("");

    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
        let newCursorPosition;
        if (showFragmentsMacros)
          newCursorPosition = beforeCursor.length + macro.name.length + 4; // +4 for the {{ and }}
        if (showVariablesMacros)
          newCursorPosition = beforeCursor.length + macro.name.length + 1; // +1 for the @
        textareaRef.current.setSelectionRange(
          newCursorPosition,
          newCursorPosition
        );
      }
    }, 0);
  };

  const calculateDropdownPosition = (textarea, cursorPosition) => {
    const {
      top: textareaTop,
      left: textareaLeft,
   
    } = textarea.getBoundingClientRect();

    const lineHeight =
      parseInt(window.getComputedStyle(textarea).lineHeight) || 20;
    const scrollTop = textarea.scrollTop;

    const textBeforeCursor = textarea.value.substring(0, cursorPosition);
    const lines = textBeforeCursor.split("\n");
    const currentLineNumber = lines.length - 1;
    const currentLine = lines[currentLineNumber];

    // Create a temporary span to measure text width
    const span = document.createElement("span");
    span.style.font = window.getComputedStyle(textarea).font;
    span.style.visibility = "hidden";
    span.style.position = "absolute";
    span.textContent = currentLine;
    document.body.appendChild(span);
    const cursorLeft = span.offsetWidth;
    document.body.removeChild(span);

    // Calculate base positions
    let cursorTop = textareaTop + currentLineNumber * lineHeight - scrollTop;
    const cursorLeftPosition = textareaLeft + cursorLeft;

    // Adjust for iOS Safari
    if (isIOS) {
      const visualViewportOffset = window.visualViewport
        ? window.visualViewport.offsetTop
        : 0;
      cursorTop -= visualViewportOffset;
    }

    // Check if dropdown would go off screen
    const dropdownHeight = 200; // max-height of dropdown
    const availableSpaceAbove = cursorTop;
    const availableSpaceBelow = viewportHeight - cursorTop;
    const shouldShowAbove =
      availableSpaceBelow < dropdownHeight &&
      availableSpaceAbove > dropdownHeight;

    return {
      top: shouldShowAbove ? cursorTop : cursorTop + lineHeight,
      left:
        cursorLeftPosition +
        parseInt(window.getComputedStyle(textarea).paddingLeft),
      position: "above",
    };
  };

  const handleKeyDown = (e) => {
    if (!showFragmentsMacros && !showVariablesMacros) return;

    const filteredFragmentsMacros = fragmentsData.filter(
      (macro) => macro.key.toLowerCase().includes(macroSearch.toLowerCase())
      //  &&
      //   macro?.isActive
    );

    const filteredVariablesMacros = variablesData.filter(
      (macro) => macro.name.toLowerCase().includes(macroSearch.toLowerCase())
      //  &&
      //   macro?.isActive
    );

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        if (showFragmentsMacros)
          setSelectedIndex((prev) =>
            prev < filteredFragmentsMacros.length - 1 ? prev + 1 : prev
          );
        if (showVariablesMacros)
          setSelectedVariablesMacrosIndex((prev) =>
            prev < filteredVariablesMacros.length - 1 ? prev + 1 : prev
          );
        break;
      case "ArrowUp":
        e.preventDefault();
        if (showFragmentsMacros)
          setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
        if (showVariablesMacros)
          setSelectedVariablesMacrosIndex((prev) =>
            prev > 0 ? prev - 1 : prev
          );
        break;
      case "Enter":
        e.preventDefault();
        if (
          selectedIndex >= 0 &&
          selectedIndex < filteredFragmentsMacros.length &&
          showFragmentsMacros
        ) {
          handleMacroSelect(filteredFragmentsMacros[selectedIndex]);
        }
        if (
          selectedVariablesMacrosIndex >= 0 &&
          selectedVariablesMacrosIndex < filteredVariablesMacros.length &&
          showVariablesMacros
        ) {
          handleMacroSelect(
            filteredVariablesMacros[selectedVariablesMacrosIndex]
          );
        }
        break;
      case "Escape":
        setShowFragmentsMacros(false);
        setShowVariablesMacros(false);
        setSelectedIndex(-1);
        setSelectedVariablesMacrosIndex(-1);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
        // &&
        // showFragmentsMacros
      ) {
        if (showFragmentsMacros) {
          setShowFragmentsMacros(false);
          setSelectedIndex(-1);
        }
        if (showVariablesMacros) {
          setShowVariablesMacros(false);
          setSelectedVariablesMacrosIndex(-1);
        }
        setMacroSearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showFragmentsMacros, showVariablesMacros]);

  return (
    <div className="relative" ref={wrapperRef}>
      <textarea
        id="value"
        ref={textareaRef}
        name="value"
        value={textAreaValue || ""}
        onChange={(e) => {
          handleChange(e);
          const value = e.target.value;
          const curPos = e.target.selectionStart;
          setCursorPosition(curPos);

          // Get cursor coordinates
          const textarea = e.target;

          // Check if we should show macro suggestions
          const lastCurlySymbol = value.lastIndexOf("{", curPos);
          const lastAtSymbol = value.lastIndexOf("@", curPos);
          if (
            lastCurlySymbol !== -1 &&
            lastCurlySymbol === value.lastIndexOf("{", curPos) &&
            value[curPos - 1] === "{"
            // &&
            // value[curPos - 1] !== "@"
          ) {
            const searchText = value.substring(lastCurlySymbol + 1, curPos);
            setMacroSearch(searchText);
            setShowFragmentsMacros(true);
            setShowVariablesMacros(false);
            setDropdownPosition(calculateDropdownPosition(textarea, curPos));
          } else if (showFragmentsMacros) {
            const searchText = value.substring(lastCurlySymbol + 1, curPos);
            setMacroSearch(searchText);
            setDropdownPosition(calculateDropdownPosition(textarea, curPos));
          } else if (
            lastAtSymbol !== -1 &&
            lastAtSymbol === value.lastIndexOf("@", curPos) &&
            value[curPos - 1] === "@"
          ) {
            const searchText = value.substring(lastAtSymbol + 1, curPos);
            setMacroSearch(searchText);
            setShowVariablesMacros(true);
            setShowFragmentsMacros(false);
            setDropdownPosition(calculateDropdownPosition(textarea, curPos));
          } else if (showVariablesMacros) {
            const searchText = value.substring(lastAtSymbol + 1, curPos);
            setMacroSearch(searchText);
            setDropdownPosition(calculateDropdownPosition(textarea, curPos));
          } else {
            setShowFragmentsMacros(false);
            setShowVariablesMacros(false);
          }
        }}
        onKeyDown={(e) => {
          handleKeyDown(e);
          if (e.key === "Escape" || e.key === " ") {
            setShowFragmentsMacros(false);
            setShowVariablesMacros(false);
          }
        }}
        onKeyUp={() => {
          // if (
          //   fragmentsData.filter(
          //     (macro) =>
          //       macro.key.toLowerCase().includes(macroSearch.toLowerCase()) &&
          //       macro?.isActive
          //   ).length === 0
          // )
          //   setShowMacros(false);
        }}
        className={`${className} focus:border-transparent max-h-[36dvh] min-h-[20vh] w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:!bg-gray-10 dark:text-white`}
        // disabled
        required
      ></textarea>

      {showFragmentsMacros && (
        <PromptFragmentsMacrosList
          dropdownPosition={dropdownPosition}
          fragmentsTableData={fragmentsData}
          setFragmentsTableData={setFragmentsData}
          macroSearch={macroSearch}
          selectedIndex={selectedIndex}
          handleMacroSelect={handleMacroSelect}
          setSelectedIndex={setSelectedIndex}
          hideDropDown={() => {
            setShowFragmentsMacros(false);
            setSelectedIndex(-1);
          }}
        />
      )}
      {showVariablesMacros && (
        <PromptVariablesMacrosList
          dropdownPosition={dropdownPosition}
          variablesTableData={variablesData}
          setVariablesTableData={setVariablesData}
          macroSearch={macroSearch}
          selectedIndex={selectedVariablesMacrosIndex}
          handleMacroSelect={handleMacroSelect}
          setSelectedIndex={setSelectedVariablesMacrosIndex}
          hideDropDown={() => {
            setShowVariablesMacros(false);
            setSelectedVariablesMacrosIndex(-1);
          }}
        />
      )}
    </div>
  );
}

export default PromptFragmentsValueTextArea;
